/** @format */

import { MultipleProductsByEcodeParams } from './multiple-products-by-ecode-params.interface';
import { ProductStyle } from '../product-style.interface';
import { ProductSku } from '../product-sku.interface';

export type PartialStyle<T extends MultipleProductsByEcodeParams> = Omit<
  ProductStyle,
  'descriptiveAttributes'
> &
  (T['attributes'] extends false
    ? unknown
    : { descriptiveAttributes: ProductStyle['descriptiveAttributes'] });

export type PartialProductsData<T extends MultipleProductsByEcodeParams> = {
  style: PartialStyle<T>;
} & (T['skus'] extends false ? unknown : { skus: ProductSku[] });

// Interface that only includes the data we expect given the request parameters
export interface MultipleProductsByEcodeResponse<
  T extends MultipleProductsByEcodeParams | undefined = undefined,
> {
  products: PartialProductsData<T>[];
}
